/* src/app/simplified-ordering/partials/simplified-ordering-form/simplified-ordering-form.component.scss */
/*# sourceMappingURL=simplified-ordering-form.component.css.map */
